import styled from 'styled-components'

import { type IDataTableProps } from '../DataTable'

interface IDataTableStyledProps {
  indentAdditionalRow?: IDataTableProps<any>['indentAdditionalRowBorder']
  clickable?: boolean
  disableScroll?: boolean
}

export const DataTableStyled = styled.div<IDataTableStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  & tbody > tr:first-child > td.body {
    border-bottom: 1px solid ${(props) => props.theme.colors.content.border};

    &:nth-child(-n + ${(props) => props.indentAdditionalRow}) {
      border-bottom: none;
    }
  }

  ${(props) =>
    props.clickable &&
    `
      & tbody > tr {
        cursor: pointer;
      }
    `}

  ${(props) =>
    props.disableScroll &&
    `
      & * {
        overflow: visible;
      }
      & table * {
        overflow: unset;
      }
    `}

  .checkbox-cell {
    cursor: pointer;
    user-select: none;
  }

  .label-icon {
    margin-left: ${(props) => props.theme.space.xsmall};
    vertical-align: middle;
  }

  .label-checkbox {
    display: inline-block;
    margin-right: ${(props) => props.theme.space.xsmall};
  }
`
